import style from "./AnalogCharacter.module.scss";
import { ReactNode, useEffect, useState } from "react";
import AnalogTransition, { Transition } from "./AnalogTransition";
import { generateUUID } from "common/utils/uuid";

const buildTransition = ({
  char,
  previousChar = "",
}: {
  char: number | string;
  previousChar?: number | string;
}): Transition => ({
  queueIndex: generateUUID(),
  char: char.toString().slice(),
  previousChar: previousChar.toString().slice(),
});

export const AnalogCharacterWrapper = ({
  fontSize,
  children,
  char,
}: {
  fontSize: string;
  children: ReactNode;
  char: number | string;
}) => {
  return (
    <div
      aria-label={char.toString()}
      className={style.wrapper}
      style={{ fontSize }}
    >
      {children}
    </div>
  );
};

export default function AnalogCharacter({
  character,
  fontSize,
}: {
  character: number | string;
  fontSize: string;
}) {
  const [previousCharacter, setPreviousCharacter] = useState(character);
  const [characterQueue, setCharacterQueue] = useState<Transition[]>([
    buildTransition({ char: character }),
  ]);
  const [isShaded, setIsShaded] = useState(false);

  const removeSelf = () => {
    if (characterQueue.length > 1) {
      setCharacterQueue(characterQueue.filter((_, index) => index !== 0));
    }
  };
  useEffect(() => {
    characterQueue.length > 1 ? setIsShaded(true) : setIsShaded(false);
  }, [characterQueue]);

  useEffect(() => {
    if (!previousCharacter) {
      setPreviousCharacter(character);
    }
    if (previousCharacter !== character) {
      const transtion = buildTransition({
        char: character,
        previousChar: previousCharacter,
      });
      setCharacterQueue([...characterQueue, transtion]);
      setPreviousCharacter(character);
    }
  }, [character, previousCharacter, characterQueue]);

  return (
    <AnalogCharacterWrapper char={character} fontSize={fontSize}>
      {characterQueue.map(({ queueIndex, char, previousChar }) => (
        <AnalogTransition
          key={queueIndex}
          character={char}
          previousCharacter={previousChar}
          onComplete={() => removeSelf()}
        />
      ))}
      <div className={style.bottomShadowContainer}>
        {isShaded && <div className={style.shading} />}
      </div>
    </AnalogCharacterWrapper>
  );
}
